export default "__VITE_ASSET__ze_N2aoJ__"